<template>
  <div class="w-full files-attachment">
    <div class="flex files-attachment__add-file">
      <div class="w-4/5 pr-2 files-attachment__upload">
        <upload-file
            automatic
            class="w-full pl-0"
            text="Drop or click to select your file here"
            @on-success="successUpload"
            @on-error="errorUpload"
            :uploadMethod="uploadFileWrapper"
            :singleUpload="true"
          />
          <small class="ml-3">This uploads a file, you must save the {{ type }} later.</small>
      </div>
      <div class="w-1/5 files-attachment__choose-file">
        <FileLookup 
          :files="files"
          @file-added="$emit('file-added', $event)"
          @file-deleted="$emit('file-deleted', $event)"
        />
      </div>
    </div>
    <div :id="id" class="vs-con-loading__container">
      <div class="w-full mt-10 files-list" v-if="files && files.length">
        <h5>Files attached to this {{ type }}</h5>
        <ul class="ml-5 mt-5 list-disc">
          <li class="border-0 border-b border-solid border-grey-light py-2 border-r-0" v-for="file in files" :key="file.id">
            <FileAttachment
              :file="file"
              :type="type"
              :content="content"
              @file-changed="$emit('file-changed', $event)"
              @file-deleted="$emit('file-deleted', $event)"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import uuid from 'uuid'
import UploadFile from "./UploadFile.vue";
import FileAttachment from './FileAttachment.vue'
import FileLookup from './FileLookup.vue'

export default {
  props: {
    type: String,
    files: Array,
    loading: Boolean,
    content: Object,
  },
  components: {
    UploadFile,
    FileAttachment,
    FileLookup
  },
  data: () => {
    return {
      id: `u${uuid.v4()}`
    }
  },
  methods: {
    ...mapActions('files', ['uploadAFile']),
    errorUpload(error) {
      this.showError(error)
    },
    successUpload() {
    },
    async uploadFileWrapper(formData) {
      try {
        this.$vs.loading();
        const response = await this.uploadAFile(formData);
        this.$emit('file-added', response)
        this.$vs.notify({
          color: "success",
          title: "Upload Success",
          text: "The file was uploaded successfully"
        });
      } catch (error) {
        this.showError(error)
      }
      this.$vs.loading.close();
    }
  },
  watch: {
    'loading': function (newValue) {
      if (newValue) {
        this.$vs.loading({
          container: `#${this.id}`,
          scale: 0.6
        })
      } else {
        this.$vs.loading.close(`#${this.id} > .con-vs-loading`)
      }
    }
  }
}
</script>

<style lang="scss">
.files-attachment {
  .list-disc {
    list-style-type: disc;
    overflow-wrap: break-word;
    word-wrap: break-word;
  }
  &__upload {
    .con-input-upload {
      margin: 0;
      width: 100%;
      height: 100px;
    }
  }
  &__add-file {
    align-items: center;
  }
}
.edit-file-prompt {
  .con-input-upload {
    margin: 0;
    width: 100%;
    height: 100px;
  }
}
</style>